import { render, staticRenderFns } from "./test-axios.vue?vue&type=template&id=27d97705&scoped=true&"
import script from "./test-axios.vue?vue&type=script&lang=js&"
export * from "./test-axios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d97705",
  null
  
)

export default component.exports